import { camelize } from "inflected";
import { parseISO, format } from 'date-fns';

export default {
  attributes() {
    if(!this.attributesCache) {
      this.attributesCache = {};
      const attributesDefinitions = this.attributesDefinitions();

      Object.entries(this.schema.attributes).forEach(([name, properties]) => {
        const attributeDefinition = attributesDefinitions[name] || {};
        this.attributesCache[name] = { ...properties, ...attributeDefinition };
        delete attributesDefinitions[name];
      })

      Object.entries(attributesDefinitions).forEach(([name, properties]) => {
        this.attributesCache[name] = { name, ...properties };
      });
    }

    return this.attributesCache;
  },

  attributesDefinition() {
    return {};
  },

  defineAttributes() {
    Object.values(this.attributes()).forEach((attribute) => {
      this.defineAttributeProperties(attribute);
    })
  },

  defineAttributeProperties(attribute) {
    const definedProperties = {};

    definedProperties[attribute.name] = {
      get: function() {
        return this["@" + attribute.name];
      },
      set: function(value) {
        if(attribute.model) {
          attribute['class'] = this.constructor.models[attribute.model]
        }
        return setAttributeValue(this, attribute, value);
      }
    }

    if(attribute.underscoreName != attribute.camelName) {
      definedProperties[attribute.underscoreName] = {
        get: function() {
          return this["@" + attribute.name];
        },
        set: function(value) {
          if(attribute.model) {
            attribute['class'] = this.constructor.models[attribute.model]
          }
          return setAttributeValue(this, attribute, value);
        }
      }
    }

    // TODO: Make less exposed
    if(attribute.type == 'datetime') {
      definedProperties[`${attribute.camelName}Time`] = {
        get: function() {
          console.log(attribute.name, ':', this[attribute.name]);
          if(this[attribute.name] instanceof Date)
            return format(this[attribute.name], 'kk:mm');

          return null;
        },
        set: function(value) {
          const parts = value.split(':');
          const hours = parseInt(parts[0], 10);
          const minutes = parseInt(parts[1], 10);
          let date;

          if(this[attribute.name] instanceof Date)
            date = this[attribute.name];
          else
            date = new Date();

          setAttributeValue(this, attribute, date);
          return date;

          // const date = this[attribute.name];
          // console.log("date", date);
          // date.setHours(hours, minutes, 0, 0);
          // this[attribute.name] = date;
          // return setAttributeValue(this, attribute, value);
        }
      }
    }

    Object.defineProperties(this.prototype, definedProperties);
  },

  getAttribute(attributeName) {
    const camelAttributeName = camelize(attributeName, false);
    return this.attributes()[camelAttributeName];
  }
}

function setAttributeValue(instance, attribute, value) {
  const parser = getAttributeParser(attribute);

  instance["@"+attribute.name] = parser(value);
};


function getAttributeParser(attribute) {
  if(attribute.type === "integer") {
    return (value) => parseInt(value)
  }

  if(attribute.type === "decimal") {
    return (value) => parseFloat(value)
  }

  if(attribute.type === "datetime" || attribute.type === "date") {
    return (value) => {
      if (value instanceof Date) {
        return value;
      }

      if (!value) return null;

      try {
        return parseISO(value);
      } catch(e) {
        return attribute.default || null;
      }
    }
  }

  if(attribute.type === "belongs_to" || attribute.type === "has_one" || attribute.type === "has_many") {
    return (value) => {
      if(!value) return attribute.default || null;

      try {
        if (Array.isArray(value)) {
          return value.map((v) => new attribute.class(v));
        }

        return new attribute.class(value);
      } catch(e) {
        return attribute.default || null;
      }
    }
  }

  return (value) => value;
}
